import React from 'react';

import { SetupMfaPageContent } from 'src/components/auth';

export const SetupMfaPage: React.FC = () => {
  return <SetupMfaPageContent />;
};
